import React from "react";
import styles from "../stylesER.module.scss";

export const InvoiceModal = ({ isOpen, monthIndex, mesesCompletos, facturas, formatCurrency, onClose }) => {
  if (!isOpen || monthIndex === null) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3>Detalle facturación - {mesesCompletos[monthIndex]}</h3>
        <table className={styles.modalTable}>
          <thead>
            <tr>
              <th className={styles.modalFacturaHeader}>Factura</th>
              <th className={styles.modalClienteHeader}>Cliente</th>
              <th className={styles.modalImporteHeader}>Importe</th>
            </tr>
          </thead>
          <tbody>
            {facturas.map((f, i) => (
              <tr key={i}>
                <td className={styles.modalFacturaData}>{f.facturanumero}</td>
                <td className={styles.modalClienteData}>{f.cliente}</td>
                <td className={styles.modalImporteData}>{formatCurrency(f.importe)}</td>
              </tr>
            ))}
            {facturas.length > 0 && (
              <tr className={styles.modalTotal}>
                <td colSpan="2">
                  <strong>Total</strong>
                </td>
                <td className={styles.modalImporteData}>
                  <strong>{formatCurrency(facturas.reduce((s, c) => s + c.importe, 0))}</strong>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className={styles.modalActions}>
          <button className={styles.btnClose} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
